import React from "react";
import ReactDOM from "react-dom/client";
import { createRoot } from "react-dom/client";
// third party
import { BrowserRouter } from "react-router-dom";
// import { Provider } from 'react-redux';
import { Provider } from "react-redux";
// project imports
// import * as serviceWorker from 'serviceWorker';
import App from "./App";
import { store } from "../src/app/store";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <Provider store={store}>
      <App />
    </Provider>
  </BrowserRouter>
);
